module.exports = __webpack_public_path__ + "img/bio-pavan-oni.6ad71a3b.png";